export default __webpack_public_path__ + "static/media/route.a00c4e86.svg";